import { render, staticRenderFns } from "./PsyTestPreSessionRequest.vue?vue&type=template&id=bb480618&scoped=true"
import script from "./PsyTestPreSessionRequest.vue?vue&type=script&lang=js"
export * from "./PsyTestPreSessionRequest.vue?vue&type=script&lang=js"
import style0 from "./PsyTestPreSessionRequest.vue?vue&type=style&index=0&id=bb480618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb480618",
  null
  
)

export default component.exports